module.exports = __webpack_public_path__ + "static/media/logo_image.00aadc9b.svg";